import { Popover } from "antd";
import React, { useState } from "react";
import CloseIcon from "../../../Common/Svgs/CloseIcon";
import WeightCollectedIcon from "../../../Common/Svgs/WeightCollectedIcon";
import ChevronIcon from "../../../Common/Svgs/ChevronIcon";
import WeightDeliveredIcon from "../../../Common/Svgs/WeightDeliveredIcon";

const NewWeightDetails = ({ activities, isOrigin, isDestination }) => {
  const [collectionOpen, setCollectionOpen] = useState(false);
  const [deliveryOpen, setDeliveryOpen] = useState(false);

  const collected = activities?.filter((item) => item?.weightCollected);
  const delivered = activities?.filter((item) => item?.weightDelivered);

  // const renderWeightCollected = () => {
  //   return (
  //     <div className="flex-1">
  //       <div className="flex items-center">
  //         <WeightCollectedIcon />

  //         <p className="ml-2 flex-1 font-aileron text-xs font-normal text-grey-200">
  //           No. of Commodities Collected
  //         </p>
  //         <p className="font-aileron text-xs font-semibold">
  //           {collected?.length || 2}
  //         </p>
  //       </div>

  //       {!isOrigin && (
  //         <div className="mt-2 flex items-center">
  //           <SpoiltMilkIcon />
  //           <p className="ml-2 flex-1 font-aileron text-xs font-normal text-grey-200">
  //             Spoilt Milk
  //           </p>
  //           <p className="font-aileron text-xs font-semibold">0</p>
  //         </div>
  //       )}
  //     </div>
  //   );
  // };

  // const renderWeightDelivered = () => {
  //   return (
  //     <div className="flex-1 flex items-center">
  //       <WeightDeliveredIcon />

  //       <p className="ml-2 flex-1 font-aileron text-xs font-normal text-grey-200">
  //         No. of Commodities Delivered
  //       </p>

  //       <p className="font-aileron text-xs font-semibold">
  //         {delivered?.length || 0}
  //       </p>
  //     </div>
  //   );
  // };

  return (
    <div className="flex gap-x-3">
      {/* {!isDestination && (
        <div
          role="button"
          className="bg-primary-10 w-full py-4 px-2 mt-3 rounded-md flex items-start justify-between"
          onClick={(e) => e.stopPropagation()}
        >
          {renderWeightCollected()}
        </div>
      )}

      {!isOrigin && (
        <div className="bg-primary-10 w-full py-4 px-2 mt-3 rounded-md flex items-start justify-between">
          {renderWeightDelivered()}
        </div>
      )} */}

      {!isDestination && (
        <Popover
          trigger="click"
          placement="bottomLeft"
          open={collectionOpen}
          arrow={false}
          content={
            <div
              className="mt-2 bg-white p-6 rounded-xl w-[337px]"
              style={{
                boxShadow: "12px 12px 16px -4px #10182814",
              }}
            >
              <div
                type="button"
                className="fixed top-0 bottom-0 right-0 left-0 w-full h-full bg-transparent -z-10 cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation();
                  setCollectionOpen(false);
                }}
              />

              <div className="flex items-center justify-between">
                <p className="font-poppins text-base font-medium text-black">
                  No. of Commodities Collected
                </p>

                <button
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    setCollectionOpen(false);
                  }}
                >
                  <CloseIcon className="w-6 h-6 stroke-dark-gray" />
                </button>
              </div>

              {collected.map((item) => {
                return (
                  <div
                    key={item.produceId}
                    className="mt-2 flex items-center justify-between py-[15px] border-b border-light-grey"
                  >
                    <p className="font-aileron font-semibold text-xs text-dark-gray capitalize">
                      {item?.produce}
                    </p>

                    <p className="font-aileron font-semibold text-xs text-black capitalize">
                      {item?.weightCollected} {item?.unit?.slice(4)}
                    </p>
                  </div>
                );
              })}
            </div>
          }
        >
          <div
            role={collected?.length > 0 && "button"}
            className="bg-primary-10 w-full py-4 px-2 mt-3 rounded-md flex items-start justify-between"
            onClick={(e) => {
              e.stopPropagation();

              if (collected?.length) {
                setCollectionOpen((prev) => !prev);
              }
            }}
          >
            <div className="flex-1">
              <div className="flex items-center">
                <WeightCollectedIcon />

                <p className="ml-2 flex-1 text-left font-aileron text-xs font-normal text-grey-200">
                  No. of Commodities Collected
                </p>

                <p className="font-aileron text-xs font-semibold">
                  {collected?.length || 0}
                </p>

                {collected.length ? (
                  <ChevronIcon
                    className={`ml-3 w-4 h-4 transform transition-all duration-[400] stroke-dark-gray
                  ${collectionOpen ? "-rotate-90" : "rotate-90"}`}
                  />
                ) : null}
              </div>
            </div>
          </div>
        </Popover>
      )}

      {!isOrigin && (
        <Popover
          trigger="click"
          placement="bottomLeft"
          open={deliveryOpen}
          arrow={false}
          content={
            <div
              className="mt-2 bg-white p-6 rounded-xl w-[337px]"
              style={{
                boxShadow: "12px 12px 16px -4px #10182814",
              }}
            >
              <div
                type="button"
                className="fixed top-0 bottom-0 right-0 left-0 w-full h-full bg-transparent -z-10"
                onClick={(e) => {
                  e.stopPropagation();
                  setDeliveryOpen(false);
                }}
              />

              <div className="flex items-center justify-between">
                <p className="font-poppins text-base font-medium text-black">
                  No. of Commodities Delivered
                </p>

                <button
                  type="button"
                  onClick={(e) => {
                    e.stopPropagation();
                    setDeliveryOpen(false);
                  }}
                >
                  <CloseIcon className="w-6 h-6 stroke-dark-gray" />
                </button>
              </div>

              {delivered.map((item) => {
                return (
                  <div
                    key={item.produceId}
                    className="mt-2 flex items-center justify-between py-[15px] border-b border-light-grey"
                  >
                    <p className="font-aileron font-semibold text-xs text-dark-gray capitalize">
                      {item?.produce}
                    </p>

                    <p className="font-aileron font-semibold text-xs text-black capitalize">
                      {item?.weightDelivered} {item?.unit?.slice(4)}
                    </p>
                  </div>
                );
              })}
            </div>
          }
        >
          <div
            role={delivered?.length > 0 && "button"}
            className="bg-primary-10 w-full py-4 px-2 mt-3 rounded-md flex items-start justify-between"
            onClick={(e) => {
              e.stopPropagation();

              if (delivered?.length) {
                setDeliveryOpen((prev) => !prev);
              }
            }}
          >
            <div className="flex-1">
              <div className="flex items-center">
                <WeightDeliveredIcon />

                <p className="ml-2 flex-1 text-left font-aileron text-xs font-normal text-grey-200">
                  No. of Commodities Delivered
                </p>

                <p className="font-aileron text-xs font-semibold">
                  {delivered?.length || 0}
                </p>

                {delivered?.length ? (
                  <ChevronIcon
                    className={`ml-3 w-4 h-4 transform transition-all duration-[400] stroke-dark-gray
                  ${deliveryOpen ? "-rotate-90" : "rotate-90"}`}
                  />
                ) : null}
              </div>
            </div>
          </div>
        </Popover>
      )}
    </div>
  );
};

export default NewWeightDetails;
